import { useCallback } from "react";
import styled from "styled-components";
import { NBSP } from "@viagogo/core/ui";
import { ChevronIcon } from "src/shared/components/ChevronIcon";
import { FormatContent } from "src/shared/components/content";
import { useFallbackImageSrc } from "src/shared/hooks/useFallbackImageSrc";
import {
  SimpleStyledPerformerName,
  StyledTopResultCard,
} from "src/website-apps/responsive/stubhub-find/components/TopResults/styled-components";
import {
  SimpleStyledContentContainer,
  StyledSquareImage,
} from "src/website-apps/shared/components/compact-category-card-and-grids/CompactCategoryCard/CompactCategoryCard.styled";
import * as icons from "src/website-apps/shared/components/instant-search-redesign-mega-search/icons/index";
import {
  DetailsContainer,
  EntrySubtitle,
} from "src/website-apps/shared/components/instant-search-redesign-mega-search/MegaSearchContents/ImageListSection/ImageListEntry/styled-components";

const SimpleStyledPerformerNameBold = styled(SimpleStyledPerformerName)`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title6)};
`;

export const TopResultCard = ({
  id,
  imageUrl,
  onClick,
  title,
  subtitle,
  iconName,
  numberRelationships,
  url,
  searchRedesign = false,
}) => {
  const fallbackImageSrc = useFallbackImageSrc();
  const handleOnClick = useCallback(() => {
    onClick(id);
  }, [id, onClick]);

  const st = subtitle ? (
    <>
      {icons && icons[iconName] ? (
        <>
          <span style={{ minWidth: "16px" }}>{icons[iconName].call()}</span>
          <NBSP />
        </>
      ) : null}

      <span>{subtitle} </span>
      {numberRelationships === undefined ? null : (
        <>
          <NBSP />
          <span>
            • <FormatContent id="cid$#3425069#" params={[numberRelationships]} raw />
          </span>
        </>
      )}
    </>
  ) : null;

  return (
    <StyledTopResultCard $searchRedesign={searchRedesign} onClick={handleOnClick} url={url}>
      <SimpleStyledContentContainer>
        <StyledSquareImage
          alt=""
          size={searchRedesign ? { height: 56, width: 56 } : { height: 44, width: 44 }}
          src={imageUrl}
          fallbackImageSrc={fallbackImageSrc}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <DetailsContainer>
            <SimpleStyledPerformerNameBold>{title}</SimpleStyledPerformerNameBold>
            {st && <EntrySubtitle>{st}</EntrySubtitle>}
          </DetailsContainer>
          <a href={url} style={{ display: "flex", alignItems: "center" }}>
            <span data-icon-wrapper="">
              <ChevronIcon />
            </span>
          </a>
        </div>
      </SimpleStyledContentContainer>
    </StyledTopResultCard>
  );
};
